import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { AuthService } from '@services/auth.service';
import { SessionService } from '@services/session.service';
import { catchError, map, of } from 'rxjs';

export const sessionOpenGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const sessionService = inject(SessionService);
  const router = inject(Router);
  const redirectToOpenSession = router.createUrlTree([AppRoutes.openSession]);

  if (!authService.isLogged() && authService.hasCheckInSession()) {
    return true;
  }

  if (!sessionService.terminalId) {
    return of(redirectToOpenSession);
  }

  return sessionService.getLastSession().pipe(
    map((session) => (session.status === 'open' ? true : redirectToOpenSession)),
    catchError(() => of(redirectToOpenSession)),
  );
};
